<template>
    <section>
        <b-card v-if='interviewLink' class='qr-card'>
            <p class='mb-0 text-center'>Филиал: {{ selectedBranch.Name_branch }}</p>
            <h4 class='text-center mb-0'>Пожалуйста, зайдите на сайт, наведя на QR-код камеру Вашего смартфона, и заполните анкету!</h4>
            <div class='d-flex qr-container'>
                <b-link :href="interviewLink" class='text-center'>Прямая ссылка</b-link>
                <vue-qrcode v-if='widthOption' ref='qrCanvas' :value="interviewLink" class='mx-auto qr-canvas' :options='{width: widthOption}'></vue-qrcode>
                <hr>
                <b-link :href="interviewLinkForeign" class='text-center'>Прямая ссылка для иностранных пациентов</b-link>
                <vue-qrcode v-if='widthOption' ref='qrCanvas' :value="interviewLinkForeign" class='mx-auto qr-canvas' :options='{width: widthOption}'></vue-qrcode>
            </div>
        </b-card>
    </section>
</template>


<script>
import { mapState } from 'vuex';
import VueQrcode from '@chenfengyuan/vue-qrcode';

export default {
    name: 'qr-for-selfrecord',
    components: {
        VueQrcode
    },
    data() {
        return {
            widthOption: null
        }
    },
    methods: {

    },
    computed: {
        ...mapState({
            interviewLink: state => state.covid.interviewLink,
            selectedBranch: state => state.covid.selectedBranch,
            interviewLinkForeign: state => state.covid.interviewLinkForeign,

        })
    },
    mounted() {
        let container = document.getElementsByClassName('qr-container');
        this.$nextTick(() => {
            this.widthOption = container[0].clientWidth * 0.65;
        })
    }
    
}
</script>

<style>
.qr-card .card-body {
    display: flex;
    flex-direction: column;
}
.qr-container {
    width: 75%;
    height: 75%;
    margin: 0 auto;
    flex-direction: column;
}
</style>


// WEBPACK FOOTER //
// src/pages/QRForSelfrecord.vue